import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

const StyledSubtitle = styled.h2`
  max-width: 383px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 24px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    max-width: 300px;
  }
`;

export default function Subtitle({ children, id }) {
  return (
    <StyledSubtitle id={id}>
      <ReactMarkdown allowedElements={['strong']} unwrapDisallowed>
        {children}
      </ReactMarkdown>
    </StyledSubtitle>
  );
}
